var T = Object.defineProperty;
var S = (r, i, n) => i in r ? T(r, i, { enumerable: !0, configurable: !0, writable: !0, value: n }) : r[i] = n;
var e = (r, i, n) => S(r, typeof i != "symbol" ? i + "" : i, n);
import { base64url as B } from "@scure/base";
import { brotliCompressSync as x, brotliDecompressSync as b } from "zlib";
import { z as o } from "zod";
import { Message as y, proto3 as a } from "@bufbuild/protobuf";
const s = class s extends y {
  constructor(n) {
    super();
    /**
     * @generated from field: string display_name = 1;
     */
    e(this, "displayName", "");
    /**
     * @generated from field: string description = 2;
     */
    e(this, "description", "");
    /**
     * @generated from field: uint32 members_count = 3;
     */
    e(this, "membersCount", 0);
    /**
     * @generated from field: string color = 4;
     */
    e(this, "color", "");
    /**
     * @generated from field: repeated uint32 tag_indices = 5;
     */
    e(this, "tagIndices", []);
    a.util.initPartial(n, this);
  }
  static fromBinary(n, t) {
    return new s().fromBinary(n, t);
  }
  static fromJson(n, t) {
    return new s().fromJson(n, t);
  }
  static fromJsonString(n, t) {
    return new s().fromJsonString(n, t);
  }
  static equals(n, t) {
    return a.util.equals(s, n, t);
  }
};
e(s, "runtime", a), e(s, "typeName", "Community"), e(s, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "members_count",
    kind: "scalar",
    T: 13
  },
  {
    no: 4,
    name: "color",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 5,
    name: "tag_indices",
    kind: "scalar",
    T: 13,
    repeated: !0
  }
]));
let u = s;
const c = class c extends y {
  constructor(n) {
    super();
    /**
     * @generated from field: string display_name = 1;
     */
    e(this, "displayName", "");
    /**
     * @generated from field: string description = 2;
     */
    e(this, "description", "");
    /**
     * @generated from field: string emoji = 3;
     */
    e(this, "emoji", "");
    /**
     * @generated from field: string color = 4;
     */
    e(this, "color", "");
    /**
     * @generated from field: Community community = 5;
     */
    e(this, "community");
    /**
     * @generated from field: string uuid = 6;
     */
    e(this, "uuid", "");
    a.util.initPartial(n, this);
  }
  static fromBinary(n, t) {
    return new c().fromBinary(n, t);
  }
  static fromJson(n, t) {
    return new c().fromJson(n, t);
  }
  static fromJsonString(n, t) {
    return new c().fromJsonString(n, t);
  }
  static equals(n, t) {
    return a.util.equals(c, n, t);
  }
};
e(c, "runtime", a), e(c, "typeName", "Channel"), e(c, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "emoji",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  {
    no: 4,
    name: "color",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  },
  { no: 5, name: "community", kind: "message", T: u },
  {
    no: 6,
    name: "uuid",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let l = c;
const m = class m extends y {
  constructor(n) {
    super();
    /**
     * @generated from field: string display_name = 1;
     */
    e(this, "displayName", "");
    /**
     * @generated from field: string description = 2;
     */
    e(this, "description", "");
    /**
     * @generated from field: string color = 3;
     */
    e(this, "color", "");
    a.util.initPartial(n, this);
  }
  static fromBinary(n, t) {
    return new m().fromBinary(n, t);
  }
  static fromJson(n, t) {
    return new m().fromJson(n, t);
  }
  static fromJsonString(n, t) {
    return new m().fromJsonString(n, t);
  }
  static equals(n, t) {
    return a.util.equals(m, n, t);
  }
};
e(m, "runtime", a), e(m, "typeName", "User"), e(m, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "display_name",
    kind: "scalar",
    T: 9
  },
  {
    no: 2,
    name: "description",
    kind: "scalar",
    T: 9
  },
  {
    no: 3,
    name: "color",
    kind: "scalar",
    T: 9
    /* ScalarType.STRING */
  }
]));
let f = m;
const d = class d extends y {
  constructor(n) {
    super();
    /**
     * Community, Channel, or User
     *
     * @generated from field: bytes content = 1;
     */
    e(this, "content", new Uint8Array(0));
    a.util.initPartial(n, this);
  }
  static fromBinary(n, t) {
    return new d().fromBinary(n, t);
  }
  static fromJson(n, t) {
    return new d().fromJson(n, t);
  }
  static fromJsonString(n, t) {
    return new d().fromJsonString(n, t);
  }
  static equals(n, t) {
    return a.util.equals(d, n, t);
  }
};
e(d, "runtime", a), e(d, "typeName", "URLData"), e(d, "fields", a.util.newFieldList(() => [
  {
    no: 1,
    name: "content",
    kind: "scalar",
    T: 12
    /* ScalarType.BYTES */
  }
]));
let p = d;
const g = o.string().regex(/^#[0-9A-Fa-f]{6}$/), k = o.string().max(30).nonempty(), N = o.object({
  displayName: k,
  description: o.string().max(140).nonempty(),
  membersCount: o.number().nonnegative(),
  color: g,
  tagIndices: o.number().nonnegative().array().optional()
});
function R(r) {
  return w(new u(r).toBinary());
}
function U(r) {
  const i = J(r), n = u.fromBinary(i.content).toJson();
  return N.parse(n);
}
const h = o.object({
  displayName: o.string().max(24).nonempty(),
  description: o.string().max(140).nonempty(),
  emoji: o.string().trim().emoji().optional(),
  color: g,
  community: o.object({
    displayName: k
  }),
  uuid: o.string().uuid()
});
function P(r) {
  return w(new l(r).toBinary());
}
function v(r) {
  const i = J(r), n = l.fromBinary(i.content).toJson();
  return h.parse(n);
}
const L = o.object({
  displayName: o.string().max(24).nonempty(),
  description: o.string().max(240).optional(),
  // fixme: await integration in native platforms
  color: g.optional().default("#ffffff")
});
function A(r) {
  return w(new f(r).toBinary());
}
function I(r) {
  const i = J(r), n = f.fromBinary(i.content).toJson();
  return L.parse(n);
}
function w(r) {
  const i = new p({
    content: r
  }).toBinary(), n = x(i);
  return B.encode(n);
}
function J(r) {
  o.string().max(500).parse(r);
  const i = B.decode(r), n = b(i);
  return p.fromBinary(n);
}
export {
  v as decodeChannelURLData,
  U as decodeCommunityURLData,
  I as decodeUserURLData,
  P as encodeChannelURLData,
  R as encodeCommunityURLData,
  A as encodeUserURLData
};
//# sourceMappingURL=encode-url-data.js.map
